import { withBoundaries } from '../../hoc';
import { SectionHeader1WidgetComponent } from './SectionHeader1Widget';
export default withBoundaries(SectionHeader1WidgetComponent);